
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockSkuDialog extends Serenity.EntityDialog<IcStockSkuRow, any> {
        protected getFormKey() { return IcStockSkuForm.formKey; }
        protected getIdProperty() { return IcStockSkuRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockSkuRow.localTextPrefix; }
        protected getNameProperty() { return IcStockSkuRow.nameProperty; }
        protected getService() { return IcStockSkuService.baseUrl; }
        protected getDeletePermission() { return IcStockSkuRow.deletePermission; }
        protected getInsertPermission() { return IcStockSkuRow.insertPermission; }
        protected getUpdatePermission() { return IcStockSkuRow.updatePermission; }

        protected form = new IcStockSkuForm(this.idPrefix);

    }
}